<template>
    <div class="row" v-if="bookingNotes != null">
      <div class="col-lg-12">
        <div class="form-box">
          <div class="form-title-wrap">
            <div class="d-flex align-items-center justify-content-between">
              <h3 class="title">{{ title }}</h3>
              <button @click="openCreateNoteModal()" class="theme-btn theme-btn-small">
                <i class="la la-plus mr-1"></i>
              </button>
            </div>
          </div>
          <div class="form-content pb-2">

            <p class="font-size-14">{{ bookingNotes.length }} listeleniyor</p>

            <div class="table-form table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Not</th>
                  <th scope="col">Tarih</th>
                  <th scope="col">Edit</th>

                </tr>
                </thead>
                <tbody>
                <tr v-for="bookingNote in bookingNotes">
                  <th scope="row">{{ bookingNote.id }}</th>
                  <th>{{ bookingNote.note }}</th>
                  <th>{{ bookingNote.createDate | ddMMyyyyHHmm }}</th>
                  <th scope="col"><button @click="deleteNote(bookingNote)" type="button" class="theme-btn theme-btn-danger-rgb font-weight-bold mr-2" data-dismiss="modal">Sil</button>
                  </th>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import messagePopupManager from "../../util/messagePopupManager";
import booking from "../../store/module/booking";

export default {
  name: "BookingNotes",
  props:{
    title:String,
    type:String
  },
  computed:{
    bookingNotes:{
      get(){
        let bookingNotes = this.$store.getters.getBookingNotes;
        if(bookingNotes !== null){
          bookingNotes = bookingNotes.filter(bookingNote => {
            return bookingNote.type === this.type});
        }
        return bookingNotes;
      }
    }
  },
  methods:{
    deleteNote(bookingNote){
      messagePopupManager.showQuestion(()=>{
        this.$store.dispatch("deleteBookingNote",bookingNote.id).then(response => {
          this.$store.dispatch("loadBookingNotes",{bookingId : bookingNote.bookingId})
        })
        // this.amount = 0;
      },"Notu silmek istediğinizden emin misiniz?")
    },
    openCreateNoteModal(bookingNote){
      this.$store.commit("setBookingNoteType", this.type);
      $("#createBookingNoteModal").modal("show");
    },
  }
}
</script>

<style scoped>

</style>